import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class ProjectPage extends Component {
	
	constructor(props) {
    	super(props);
    }
    
    state = {
		isOpen: false,
	};
	
	handleToggle = (evt) => {
		evt.preventDefault();
		window.scrollTo(0,0);
    	this.setState({ isOpen: !this.state.isOpen });
  	};
  	
	componentDidMount() {
		setTimeout(() => {
			if (document.getElementsByClassName('slick-cover').length > 0) {
				document.getElementsByClassName('slick-cover')[0].classList.add('state-inactive');
			}
		}, 2000);
		setTimeout(() => {
			window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseover', function(){
				document.documentElement.classList.add('state-prev-hover');
			});
			window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseout', function(){
				document.documentElement.classList.remove('state-prev-hover');
			});
			window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseover', function(){
				document.documentElement.classList.add('state-next-hover');
			});
			window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseout', function(){
				document.documentElement.classList.remove('state-next-hover');
			});
		}, 500);
	}
  			
	render() {
		
		let post = this.props.post;
		
		if (post.gallery) {
	    	const settings = {
				dots: false,
				arrows: true,
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1
			};
			
			const slides = post.gallery.map((slide,i) =>
				{
					if (i === 0) {
						return (
							<div className="inner">
								<div className="left">
									<h4 className="c-paragraph c-paragraph--xxlarge" dangerouslySetInnerHTML={{__html:post.title}}></h4>
									{post.number &&
										<h5 className="c-paragraph c-paragraph--xxlarge c-paragraph--light" dangerouslySetInnerHTML={{__html:'(0' + post.number + ')'}}></h5>
									}
									{post.suburb &&
										<p className="c-paragraph c-paragraph--xxlarge c-paragraph--light" dangerouslySetInnerHTML={{__html:post.suburb}}></p>
									}
								</div>
								<div className={'right ' + slide.fitting}>
									<FadeIn key={i}>
										{onload => (
											<img
												alt={''} 
												src={slide.src} 
												srcSet={slide.srcset} 
												onLoad={onload}
											/>
										)}
									</FadeIn>
								</div>
							</div>
						)
					} else {
						return (
							<div className="inner">
								<div className={'full ' + slide.fitting}>
									<FadeIn key={i}>
										{onload => (
											<img
												alt={''} 
												src={slide.src} 
												srcSet={slide.srcset} 
												onLoad={onload}
											/>
										)}
									</FadeIn>
								</div>
							</div>
						)
					}
				}
			);
			
			let proClass = 'c-project';
			if (this.state.isOpen == true) {
				proClass = 'c-project state-info-open';
			}

			return (
				
				<div className={proClass}>
					
					<div className="c-project__gallery">
						<div className="c-project__gallery__top">
							<h2 className="c-project__gallery__text" dangerouslySetInnerHTML={{__html:post.title}}></h2>
						</div>
						<div className="scope-slick">
							<div>
								<Slider {...settings}>
									{slides}
								</Slider>
							</div>
						</div>
						<div className="c-project__gallery__bottom">
							<a href="#" className="c-project__gallery__text c-paragraph--underline" onClick={this.handleToggle}>Read more</a>
							<Link to={{ pathname: '/projects'}} dangerouslySetInnerHTML={{__html:'Back'}} className="c-project__gallery__text"></Link>
						</div>
					</div>
					
					<div className="c-project__desktop-info">
						
						<div className="l-content">
							
							<div className="l-grid">
							
								<div className="l-grid__col l-grid__col--l-3-12 c-project__desktop-info__section">
									
									<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:post.ptype}}></h4>
									
								</div>
								
								<div className="l-grid__col l-grid__col--l-4-12 c-project__desktop-info__section">
									
									{!this.state.isOpen &&
										<a href="#" className="c-paragraph c-paragraph--underline" onClick={this.handleToggle}>Read more</a>
									}
									{this.state.isOpen &&
										<a href="#" className="c-paragraph c-paragraph--underline" onClick={this.handleToggle}>Close</a>
									}
									
								</div>
								
								<div className="l-grid__col l-grid__col--l-4-12 l-grid__col--l-push-1-12 c-project__desktop-info__section">
									
									{post.now_selling && post.show_now_selling === 'true' && post.now_selling_text &&
										<a className="c-paragraph c-paragraph--selling" href={post.now_selling} target="_blank" dangerouslySetInnerHTML={{__html:post.now_selling_text + ' <svg class="c-arrow" x="0px" y="0px" viewBox="0 0 46 36"><path style="fill:#DC4233;" d="M22.22,0.05l15.78,15.89H0.46v3.93h37.71L22.22,35.95h5.44L45.54,18L27.65,0.05H22.22 z"/></svg>'}}></a>	
									}
									{!post.now_selling && post.show_now_selling === 'true' && post.now_selling_text &&
										<p className="c-paragraph" dangerouslySetInnerHTML={{__html:post.now_selling_text }}></p>	
									}
									
									<Link to={{ pathname: '/projects'}} dangerouslySetInnerHTML={{__html:'Back'}} className="c-project__desktop-info__back c-paragraph"></Link>
									
								</div>
								
								<div className="l-grid__col c-project__desktop-info__section">
									<div className="c-project__desktop-info__rule"></div>
								</div>
								
								<div className="l-grid__col l-grid__col--l-3-12 c-project__desktop-info__section">
									
									<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:post.title}}></h4>
									{post.number &&
										<h5 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:'(0' + post.number + ')'}}></h5>
									}
									{post.suburb &&
										<p className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:post.suburb}}></p>
									}
									
								</div>
								
								<div className="l-grid__col l-grid__col--l-4-12 c-project__desktop-info__section">
									
									<div className="c-project__desktop-info__cols">
										{post.details.map((detail,i) =>
											{
												return (
													<div>
														<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:detail.label}}></h6>
														<p className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={{__html:detail.text}}></p>
													</div>
												)
											}		
										)}
										{post.status &&
											<div>
												<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:"Status"}}></h6>
												<p className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={{__html:post.status}}></p>
											</div>
										}
									</div>
									
								</div>
								
								<div className="l-grid__col l-grid__col--l-4-12 l-grid__col--l-push-1-12 c-project__desktop-info__section">
									
									<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:"Overview"}}></h6>
									<div className="scope-text" dangerouslySetInnerHTML={{__html:post.overview}}></div>
									
								</div>
							
							</div>
							
						</div>
						
					</div>
							
					<div className="c-project__mobile-info">
						
						<div className="l-content">
							
							<div className="l-grid">
							
								<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section">
								
									<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:post.title}}></h4>
									{post.number &&
										<h5 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:'(0' + post.number + ')'}}></h5>
									}
									{post.suburb &&
										<p className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:post.suburb}}></p>
									}
								</div>
								
								<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section">
									{post.ptype &&
										<p className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:post.ptype}}></p>
									}
								</div>
								
								{post.now_selling && post.show_now_selling === 'true' && post.now_selling_text &&
									<>
										<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section"></div>
										<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section">
											<a className="c-paragraph c-paragraph--selling" href={post.now_selling} target="_blank" dangerouslySetInnerHTML={{__html:post.now_selling_text + ' <svg class="c-arrow" x="0px" y="0px" viewBox="0 0 46 36"><path style="fill:#DC4233;" d="M22.22,0.05l15.78,15.89H0.46v3.93h37.71L22.22,35.95h5.44L45.54,18L27.65,0.05H22.22 z"/></svg>'}}></a>	
										</div>
									</>
								}
								{!post.now_selling && post.show_now_selling === 'true' && post.now_selling_text &&
									<>
										<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section"></div>
										<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section">
											<p className="c-paragraph" dangerouslySetInnerHTML={{__html:post.now_selling_text }}></p>
										</div>
									</>
								}
								
							</div>
							
						</div>
							
						<div className="c-project__mobile-info__rule"></div>
						
						<div className="l-content">
							
							<div className="l-grid">
							
								<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section"></div>
								
								<div className="l-grid__col l-grid__col--xs-3-6 c-project__mobile-info__section">
									{post.details.map((detail,i) =>
										{
											return (
												<>
													<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:detail.label}}></h6>
													<p className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={{__html:detail.text}}></p>
												</>
											)
										}		
									)}
									{post.status &&
										<>
											<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:"Status"}}></h6>
											<p className="c-paragraph" dangerouslySetInnerHTML={{__html:post.status}}></p>
										</>
									}
								</div>
								
							</div>
							
						</div>	
						
						{post.overview &&
							
							<>
							
								<div className="c-project__mobile-info__rule"></div>
								
								<div className="l-content">
									
									<div className="l-grid">
									
										<div className="l-grid__col c-project__mobile-info__section">
											<h6 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:"Overview"}}></h6>
											<div className="scope-text" dangerouslySetInnerHTML={{__html:post.overview}}></div>
										</div>
									
									</div>
									
								</div>
								
							</>
							
						}
						
						<div className="c-project__mobile-info__footer">
							<a href="#" className="c-paragraph" onClick={this.handleToggle}>Close</a>
							<Link to={{ pathname: '/projects'}} dangerouslySetInnerHTML={{__html:'Back'}} className="c-paragraph"></Link>
						</div>
											
					</div>
				
				</div>
				
			);
			
		} else {
			return null;
		}
	}
}